<template>
  <section class="listClient">
    <fieldset class="group"> 
      <legend>List Clients</legend>
      <ul class="checkbox">
        <li v-for="(client, key) in listClients" :key="key">
          <input type="checkbox" :id="client" :value="client"  v-model="checkedClients">
          <label :for="client">{{client}}</label>
        </li>
      </ul>
    </fieldset>
    <button @click="getList">Get List Clients</button>
    <button @click="getLinkTo">Link To</button>
  </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "listClient",
  data() {
    return {
      checkedClients: []
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapState(["listClients", "admin"])
  },
  methods: {
    ...mapMutations(["updateListClients"]),
    getList() {
      this.$socket.emit("reqListClients");
    },
    getLinkTo() {
      this.$socket.emit("reqLinkTo", {
        clients: this.checkedClients,
        admin: this.admin
      });
    }
  },
  sockets: {
    resListClients(data) {
      this.updateListClients(data);
    }
  }
};
</script>

<style>
  fieldset.group  { 
    margin: 0; 
    padding: 0; 
    margin-bottom: 1.25em; 
    padding: .125em; 
  } 

  fieldset.group legend { 
    margin: 0; 
    padding: 0; 
    font-weight: bold; 
    margin-left: 20px; 
    font-size: 100%; 
    color: black; 
  } 


  ul.checkbox  { 
    margin: 0; 
    padding: 0; 
    margin-left: 20px;
    list-style: none; 
  } 

  ul.checkbox li input { 
    margin-right: .25em; 
  } 

  ul.checkbox li {
  border: 1px transparent solid;
  float: left;
  min-width: 100px;
  }

  ul.checkbox li label { 
    margin-left: auto;
    font-weight: 500; 
  } 
</style>
